const scrollToElement = (element, params) => {
  if (element) {
    // Check if we're inside an editor context by looking for the toolbar
    const toolbar = document.querySelector('.toolbar-wrapper, .toolbar, .tabs');

    if (toolbar) {
      // Get the toolbar's position and height
      const toolbarRect = toolbar.getBoundingClientRect();
      const toolbarBottom = toolbarRect.bottom;

      // Get element position
      const elementRect = element.getBoundingClientRect();
      const elementTop = elementRect.top;

      // If element would scroll above toolbar, adjust the scroll to keep toolbar visible
      if (elementTop < toolbarBottom + 20) {
        // Calculate the offset needed to keep element below toolbar
        const scrollOffset = window.pageYOffset + elementTop - toolbarBottom - 40; // 40px buffer

        window.scrollTo({
          top: scrollOffset,
          behavior: params?.behavior || "smooth"
        });
      } else {
        // Normal scroll if toolbar won't be affected
        element.scrollIntoView({
          behavior: params?.behavior || "smooth",
          block: params?.block || "center", // Changed from "start" to "center" for better visibility
        });
      }
    } else {
      // Fallback to normal scrollIntoView if no toolbar found
      element.scrollIntoView({
        behavior: params?.behavior || "smooth",
        block: params?.block || "center", // Changed from "start" to "center"
      });
    }
  }
};

export default scrollToElement;
